const arrayCheck = (data) => Array.isArray(data) && data.length > 0;

export default arrayCheck;
